<alaris-dialog
	[closeAction]="close.bind(this)"
	[confirmAction]="confirm.bind(this)"
	[loading$]="sourcesService.loading$"
	[confirmButtonText]="'gl.delete'"
	[disabled]="sourceUsed()"
	size="md"
	class="removingDialog"
>
	<h4 slot="header">
		{{ 'sources.removing_dialog_title' | translate }}
	</h4>
	<div slot="content">
		<p>
			@if (sourceUsed()) {
				{{ 'sources.removing_error_dialog' | translate }}
				@for (id of rulesSignal(); track id) {
					<li>
						<strong>{{ 'rules.id' | translate }}: {{ id }}</strong>
					</li>
				}
			} @else {
				{{ 'sources.removing_dialog' | translate }}{{ data.source.name }}
			}
		</p>
	</div>
</alaris-dialog>
